// @flow
import * as React from 'react';
import CustomerDetailsForm from './CustomerDetailsForm';
import AgencyRequestModal from '../../components/AgencyRequestModal';
import type { Authentication, Organisation } from '../../types';

type Props = {
  params: {
    customerId: string
  },
  router: any,
  currentCustomer: Organisation,
  authentication: Authentication,
  updateCurrentCustomer: (i: number, s?: boolean) => Promise<Organisation>,
  getCustomerSettings: (i?: ?number) => Promise<void>,
  updateCustomer: (o: Organisation) => Promise<Object>,
  addCustomer: (o: Organisation) => Promise<Object>
};

type State = {
  isSaving: boolean,
  errorMsg: ?string,
  successMsg?: string,
  agencyRequest?: boolean
};

export default class CustomerDetails extends React.Component<Props, State> {
  timeoutId: any;
  screenReaderContent: any;
  static displayName = 'CustomerDetails';

  constructor(props: Props) {
    super(props);
    this.state = {
      isSaving: false,
      errorMsg: undefined
    };
    this.timeoutId = undefined;
  }

  componentDidMount() {
    const customerId = parseInt(this.props.params.customerId, 10);
    if (customerId) {
      this.props.updateCurrentCustomer(customerId);
    }

    this.screenReaderContent.focus();
  }

  componentWillUnmount() {
    // clear timeout to prevent setState on unmounted component
    clearTimeout(this.timeoutId);
  }

  handleSubmit = (values: any) => {
    this.setState({ isSaving: true, errorMsg: undefined });
    if (values.id) {
      this.props
        .updateCustomer(values)
        .then(
          response => this.success(response, false, values.agencyRequest),
          error => this.failure(error)
        );
    } else {
      this.props
        .addCustomer(values)
        .then(
          response => this.success(response, true),
          error => this.failure(error)
        );
    }
  };

  success = (
    response: any,
    redirect: boolean = false,
    agencyRequest: boolean = false
  ) => {
    this.setState({
      isSaving: false,
      errorMsg: undefined,
      successMsg: 'Success!',
      agencyRequest
    });
    this.timeoutId = setTimeout(
      () => this.setState({ successMsg: undefined }),
      3000
    );

    if (redirect) {
      const newCustomerId = response.data.id;
      this.props.router.push(`/customers/${newCustomerId}`);
    }
  };

  failure = (error: any) => {
    this.setState({ isSaving: false, errorMsg: error.data.message });
  };

  closeModal = () => {
    this.setState({
      agencyRequest: false
    });
  };

  render() {
    return (
      <div>
        <h3
          className="screen-reader-only"
          tabIndex="-1"
          ref={i => (this.screenReaderContent = i)}
        >
          Showing details for customer {this.props.currentCustomer.name}
        </h3>

        <CustomerDetailsForm
          onSubmit={this.handleSubmit}
          initialValues={this.props.currentCustomer}
          enableReinitialize={true}
          currentCustomer={this.props.currentCustomer}
          isNew={this.props.params.customerId === 'new'}
          isSaving={this.state.isSaving}
          errorMsg={this.state.errorMsg}
          successMsg={this.state.successMsg}
          isInternalAdminUser={
            this.props.authentication.user.isInternalAdminUser
          }
        />
        <AgencyRequestModal
          show={this.state.agencyRequest}
          onHide={this.closeModal}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/customer/CustomerDetails.js